// extracted by mini-css-extract-plugin
export default {"label":"style--label--f2e8bc","row":"style--row--fde5d4"};